import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import {Input, StripeCard, Select} from '../form';
import {createOrg, getUserOrgs} from '../../api/'
import {navigateTo} from 'gatsby-link'
import * as Paths from '../../constants/Paths'
import AppState from '../../state/AppState'
import {setUserSetting} from '../../actions/SettingsActions'
import {TIMEZONES} from '../../constants/Timezones';

class CreateOrgForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      serverError: null
    };

  }

  onValidSubmit(model) {

    const { onSuccess = _.noop, onError = _.noop } = this.props;
    this.setState({isProcessing: true, serverError: null});

    // TODO: Make this an action
    createOrg(model.name, model.cardToken.id)
      .then((createResult) => {
        return getUserOrgs().then((getOrgsResult) => {
          AppState.selectOrg(createResult.org);
          AppState.setOrgs(getOrgsResult.orgs.items);
          if (getOrgsResult.orgs.items.length === 1) setUserSetting("defaultorg", createResult.org.id);
          navigateTo(Paths.DB_ORG_HOME.replace(":orgId", createResult.org.id) + "?welcome=1")
        })
      })
      .catch((e) => {
        this.setState({isProcessing: false, serverError: e.message});
        onError(e.message);
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, serverError } = this.state;
    const { onCancel = _.noop } = this.props;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onInvalidSubmit={() => this.onInvalidSubmit() }>
        <div className="form-fields">
          <Input name="name"
                 type="text"
                 icon="build"
                 inputSize="pt-large"
                 label="Company name:"
                 showErrors={showErrors}
                 required />
          <StripeCard name="cardToken"
                      type="text"
                      icon="credit-card"
                      inputSize="pt-large"
                      label="Payment Info:"
                      showErrors={showErrors}
                      required />
          <div className="pt-callout pt-intent-primary">
            <h5>Card won't be charged.</h5>
            <p>Your card won't be charged until the 7-day trial expires.  You are free to cancel at any time.</p>
          </div>
          </div>
          <div className="form-submit-group grid-row">
            <div className="grid-item grid-row v-align">
              {serverError && (
                <div className="error-message">
                  {serverError}
                </div>
              )}
            </div>
            <div>
              <button type="button"
                      className="pt-button pt-large sr2" onClick={() => onCancel() }>Cancel</button>
              {!isProcessing ? (
                <button type="submit" className="pt-button pt-intent-primary3 pt-large sr2">Start Organization</button>
              ) : (
                <button type="submit" className="pt-button pt-intent-primary3 pt-large">Activating...</button>
              )}
            </div>
          </div>
      </Formsy>
    );
  }
}

export default CreateOrgForm;


// WEBPACK FOOTER //
// ./src/components/forms/CreateOrgForm.js